module.exports = __webpack_public_path__ + "img/australia-breast-cancer-female.682163e7.png";